/**
 * 获取交底书任务名称的能力
 */
export interface DisclosureTaskNameGetter {
    /**
     * 获取交底书任务名称
     * @param taskId 任务ID
     * @returns 任务名称
     */
    getTaskName(taskId: string): Promise<string>;
}

export const DisclosureTaskNameGetter = Symbol('DisclosureTaskNameGetter');

/**
 * 设置交底书任务名称的能力
 */
export interface DisclosureTaskNameSetter {
    /**
     * 设置翻译任务名称
     * @param taskId 任务ID
     * @param taskName 任务名称
     */
    setTaskName(taskId: string, taskName: string): Promise<void>;
}

export const DisclosureTaskNameSetter = Symbol('DisclosureTaskNameSetter');
